import {fabric} from 'fabric'

function BaseAnnotation(annoLayer, opt) {
  console.log(opt)
  this.annoLayer = annoLayer
  this.baseProps = {
    hasControls: false,
    hasRotatingPoint: false,
    noScaleCache: false,
    objectCaching: false,
    object_id: opt.object_id,
  }
  switch (opt.annoType) {
    case 'link':
      return this.createLink(opt)
    default: {
      return null
    }
  }
}

BaseAnnotation.prototype.createLink = function createLink(opt) {
  const rect = this.annoLayer.convertToViewPortRect(opt.rect);
  const linkProps = {
    lockMovementX: true,
    lockMovementY: true,
    lockScalingFlip: true,
    lockScalingX: true,
    lockScalingY: true,
    left: rect[0],
    top: rect[1],
    width: rect[2],
    height: rect[3],
    hoverCursor: 'pointer',
    opacity: 0
  }
  const link = new fabric.Rect(Object.assign(this.baseProps, linkProps))
  link.on('mouseup', function () {
    window.open(opt.url, '_blank')
  })
  link.on('mouseover',  () => {
    const viewRect = this.annoLayer.convertToViewPortRect(opt.rect)
    let hintTop = parseInt(viewRect[1] - viewRect[3], 10) - 2
    const hintElem = document.createElement('div')
    hintElem.className = 'folia-link-hint'
    hintElem.innerText = opt.url
    hintElem.style.position = 'absolute'
    hintElem.style.left = `${parseInt(viewRect[0], 10)}px`
    hintElem.style.top = `${hintTop}px`
    this.annoLayer.canvas.wrapperEl.appendChild(hintElem)
  })
  link.on('mouseout',  () => {
    const hints = this.annoLayer.canvas.wrapperEl.querySelector('.folia-link-hint')
    if (hints) hints.remove()
  })
  return link
}

export default BaseAnnotation